import KsbAlert from "../../../../2_ksbHub/components/KsbAlert";

function EventManagerAlerts({
  showUnlockedToast,
  setShowUnlockedToast,
  errorMessage,
  setErrorMessage,
}) {
  return (
    <>
      {/* ✅ SUCCESS / INFO */}
      <KsbAlert
        open={showUnlockedToast}
        onClose={() => setShowUnlockedToast(false)}
        message="Reservierung ist jetzt geöffnet!"
      />

      {/* ✅ ERROR */}
      <KsbAlert
        open={!!errorMessage}
        onClose={() => setErrorMessage("")}
        message={errorMessage}
        severity="error"
      />
    </>
  );
}

export default EventManagerAlerts;
